import React from 'react';
import PropTypes from 'prop-types';
import { CgMoveLeft } from 'react-icons/cg';
import { useHistory } from 'react-router-dom';
import { RiArrowRightSLine } from 'react-icons/ri';
import { MENUITEMS } from '../../constants/sidemenu';

import {
  MenuContainer,
  SlidingMenuWrapper,
  TitleContainer,
  Title,
  CloseAction,
  LinkItemWrapper,
  LinkItem,
  LinkIcon,
  LinkLabel,
  LinkSubtitle,
  LinkArrow,
  MenuDividerTitle,
} from './styles';

const DrawerMenu = ({
  state,
  toggleMenu,
  virtualPhoneNumber,
}) => {
  const history = useHistory();
  // const [activeMenu, activeMenu] = useState('');
  const handleMenuItemClick = (m) => {
    if (m.isComing) return;
    toggleMenu();
    history.push(`${m.URL}${virtualPhoneNumber}`);
  };

  const renderLinkItem = (m) => (
    <LinkItemWrapper isDarkMode key={m.position} onClick={() => handleMenuItemClick(m)}>
      <LinkItem isDarkMode>
        <LinkIcon isComing={m.isComing}>{m.icon}</LinkIcon>
        <LinkLabel isComing={m.isComing}>{m.label}</LinkLabel>
        <LinkArrow>
          <RiArrowRightSLine />
        </LinkArrow>
      </LinkItem>
      <LinkSubtitle>{m.subtitle}</LinkSubtitle>
    </LinkItemWrapper>
  );

  return (
    <SlidingMenuWrapper state={state}>
      <MenuContainer state={state}>
        <TitleContainer onClick={() => toggleMenu()}>
          <Title>Menu</Title>
          <CloseAction>
            <CgMoveLeft />
          </CloseAction>
        </TitleContainer>

        {MENUITEMS.filter((m) => m.isComing === false).map((m) => renderLinkItem(m))}

        <MenuDividerTitle>coming soon</MenuDividerTitle>
        {MENUITEMS.filter((m) => m.isComing === true).map((m) => renderLinkItem(m))}
      </MenuContainer>
    </SlidingMenuWrapper>
  );
};

DrawerMenu.defaultProps = {};

DrawerMenu.propTypes = {
  state: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  virtualPhoneNumber: PropTypes.string.isRequired,
};

export default DrawerMenu;
